import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ArrayField,
  SingleFieldList,
  SearchInput,
  SelectInput,
  Filter,
  Pagination,
  useListContext,
} from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { useFormState } from 'react-final-form';
import { districtOptions, blockOptions } from '../../../meta/filterOption';

// choice mapping
const toChoices = (items) =>
  items && items.map((item) => ({ id: item, name: item }));
// school renderer
// const schoolCodeRenderer = (choice) => {
//   return choice != null ? `${choice.id} - ${choice.school_name}` : '';
// };

// block filter input
const BlockInput = (props) => {
  const { values } = useFormState();
  const { displayedFilters } = useListContext();
  return displayedFilters['data.district'] ? (
    <SelectInput
      choices={
        values.data && values.data.district
          ? toChoices(blockOptions[values.data.district])
          : []
      }
      {...props}
    />
  ) : (
    ''
  );
};

// school filter input
// const SchoolInput = (props) => {
//   const { values } = useFormState();
//   return (
//     <ReferenceInput
//       format={(v) => (!v ? null : v)}
//       sort={{ field: 'school_code', order: 'ASC' }}
//       filter={{
//         district: values.data && values.data.district,
//         block: values.data && values.data.block,
//       }}
//       filterToQuery={(searchText) => ({ school_name: searchText })}
//       {...props}
//     >
//       <AutocompleteInput
//         optionValue='school_name'
//         optionText={schoolCodeRenderer}
//       />
//     </ReferenceInput>
//   );
// };

// search filter
const SearchFilter = (props) => {
  const userData = JSON.parse(
    localStorage.getItem('Dashboard-App/local_sql/user')
  );
  const {
    user: {
      data: {
        roleData: { district },
      },
    },
  } = userData;

  const { displayedFilters, filterValues, setFilters } = useListContext();

  if (
    displayedFilters['data.block'] &&
    (displayedFilters['data.district'] === false ||
      displayedFilters['data.district'] === undefined)
  ) {
    displayedFilters['data.block'] = false;
    setFilters({});
  }

  const districtChange = (e) => {
    if (filterValues.data.district !== e.target.value) {
      setFilters({
        data: {
          district: e.target.value,
        },
      });
    }
  };

  const blockChange = (e) => {
    if (filterValues.data.block !== e.target.value) {
      setFilters({
        data: {
          district: filterValues.data.district,
          block: e.target.value,
        },
      });
    }
  };

  const userDistrict = [{ id: district, name: district }];
  return (
    <Filter {...props}>
      <SearchInput
        placeholder='Search by name*'
        source='data.name'
        className='searchBar'
        key='1'
        alwaysOn
      />
      <SelectInput
        label='By District'
        source='data.district'
        choices={
          district === 'ALL' || district === ''
            ? toChoices(districtOptions)
            : userDistrict
        }
        className='autocompleteInput'
        onChange={(e) => districtChange(e)}
        allowEmpty={false}
      />
      <BlockInput
        label='By Block'
        source='data.block'
        className='autocompleteInput'
        onChange={(e) => blockChange(e)}
        allowEmpty={false}
      />
    </Filter>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'calc(100% - 0px)',
    height: '86vh',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    overflowY: 'scroll',
    marginLeft: '1rem',
  },
}));

export const CovidEmployeesList = (props) => {
  const classes = useStyles();
  const userData = JSON.parse(
    localStorage.getItem('Dashboard-App/local_sql/user')
  );
  const {
    user: {
      data: {
        roleData: { district },
      },
    },
  } = userData;
  return (
    <div className={classes.root}>
      <List
        {...props}
        filters={<SearchFilter />}
        filterDefaultValues={
          district === 'ALL' || district === ''
            ? {}
            : {
                data: {
                  district,
                },
              }
        }
        pagination={<Pagination perPage={1} style={{ float: 'left' }} />}
        title='Reported COVID Positive Employees'
        className='customBox'
      >
        <Datagrid>
          <TextField
            label='Reporting Person Designation'
            source='data[0].designation'
          />
          <TextField label='Reporting Person Name' source='data[0].name' />
          <ArrayField label='District' source='data'>
            <SingleFieldList>
              <TextField source='district' />
            </SingleFieldList>
          </ArrayField>
          <ArrayField label='Block' source='data'>
            <SingleFieldList>
              <TextField source='block' />
            </SingleFieldList>
          </ArrayField>
          <TextField label='School Name' source='data[0].school' />
          <TextField
            label='Reported Person Name'
            source='data[0].teacher_name'
          />
          <DateField label='Test Date' source='data[0].test_date' />
          <DateField
            label='Last Present Date'
            source='data[0].last_present_date'
          />

          {/* <ImageField
            label='Report Image'
            source='data[0].report_image.filename'
            title='data[0].report_image.filename'
          /> */}
        </Datagrid>
      </List>
    </div>
  );
};
